import { isString } from 'lodash/fp';
import type { HTMLElementID, Rect } from 'app/lib/types/ui';

export function createVirtualElement({ x = 0, y = 0, width = 0, height = 0 }: Partial<Rect>) {
    return {
        getBoundingClientRect() {
            return {
                x,
                y,
                width: width,
                height: height,
                top: y,
                left: x,
                bottom: y + height,
                right: x + width
            };
        }
    };
}

export type ReferenceElement = HTMLElement | HTMLElementID;

export function resolveReferenceElement(reference?: ReferenceElement) {
    if (reference instanceof HTMLElement) {
        return reference;
    }

    if (isString(reference)) {
        return document.getElementById(reference);
    }

    return null;
}
